export default {
  data() {
    return {
      valuesObj: {
        USD    : {
          value: 'USD',
          label: '$',
          label_text: 'USD',
        },
        EURO   : {
          value: 'EURO',
          label: '€',
          label_text: 'EUR',
        },
        RUR    : {
          value: 'RUR',
          label: '₽',
          label_text: 'RUB',
        },
        UAH   : {
          value: 'UAH',
          label: '₴',
          label_text: 'UAH',
        }
      },
      values   : [],
      T_min:null,
      T_max:null,
      T_on_min: null,
      T_on_max: null,
      is_curr_changed: false,

      filters: {},
      T_filters:null,
      cl_filters: [],

      price_min_in: 0,
      price_max_in: 0,
      currency_in: 'USD',

      is_currency_slider: false,
    }
  },

  created() {
    this.$store.dispatch ('addUsedFilters', 'Prices');

    this.values = [
      this.valuesObj['USD'],
      this.valuesObj['EURO'],
      this.valuesObj['RUR'],
      this.valuesObj['UAH'],
    ];
  },

  computed  : {
    is_show_filter: {
      get () {
        if ( this.$store.getters.prices==null || this.$store.getters.prices.length==0 || $.isEmptyObject(this.$store.getters.prices) ) {
          if ( this.$store.getters.filters.price_min!=null ){
            //чтобы теги поставить
            this.set_tag_min(this.$store.getters.filters.price_min);
          }
          if ( this.$store.getters.filters.price_max!=null ){
            //чтобы теги поставить
            this.set_tag_max(this.$store.getters.filters.price_max);
          }

          //выводим фильтр всегда, т.к. нужно чтобы можно было поменять валюту
          //return false;
        }
        return true;
      },
    },

    //границы цен
    min_from: {
      get () {
        if ( this.$store.getters.prices==null || this.$store.getters.prices.length==0 || $.isEmptyObject(this.$store.getters.prices) ) return 0;
        return parseInt(this.$store.getters.prices[this.currency_in]['min']);
      },
    },
    max_to: {
      get () {
        if ( this.$store.getters.prices==null || this.$store.getters.prices.length==0 || $.isEmptyObject(this.$store.getters.prices) ) return 0;
        return parseInt(this.$store.getters.prices[this.currency_in]['max']);
      },
    },

    class_: {
      get() {
        let tmp='works-filter__block works-filter__block-sale-type';
        if ( !this.is_show ) tmp+=' works-filter__block-advanced';
        return tmp;
      }
    },

    advanced: {
      get () {
        return (this.is_show || this.$store.getters.advanced);
      }
    },

    //установленные значения
    price_min: {
      get() {
        let value = this.$store.getters.filters.price_min;

        clearTimeout(this.T_on_min);
        this.T_on_min=setTimeout( ()=>{
          this.on_periodChange(value, null);
          this.set_tag_min(value);
          this.price_min_in=value;
        }, 100 );

        return value;
      },
      set(value) {
        this.price_min_in=value;

        if (this.is_currency_slider){
          clearTimeout( this.T_min );
          this.T_min=setTimeout( ()=>{
            this.set_price_min(value);
          }, 700 );
        }
      },
    },
    price_max: {
      get() {
        let value = this.$store.getters.filters.price_max;

        clearTimeout(this.T_on_max);
        this.T_on_max=setTimeout(()=>{
          this.on_periodChange(null, value);
          this.set_tag_max(value);
          this.price_max_in=value;
        }, 100);

        return value;
      },
      set(value) {
        this.price_max_in=value;

        if (this.is_currency_slider){
          clearTimeout( this.T_max );
          this.T_max=setTimeout( ()=>{
            this.set_price_max(value);
          }, 700 );
        }
      },
    },

    currency : {
      get() {
        let value = this.$store.getters.filters.currency;

        if (value == null) value = this.$store.getters.user_currency.toUpperCase();
        if (value == null) value='USD';
        value = this.valuesObj[value];
        this.currency_in=value.value;
        return value;
      },
      set(valueObj) {
        if(!valueObj) return false;
        this.currency_in=valueObj.value;

        this.is_curr_changed=true;

        let value    = valueObj.value;
        if (value !== undefined) {
          if (this.is_currency_slider){
            value = value.toString();
            if ( value===this.$store.getters.user_currency.toUpperCase() ) value='';

            this.price_min_in='';
            this.price_max_in='';
            this.$store.dispatch('setFilters', {'p':1, currency: value, price_min:'', price_max:''}).then(() => {});
          }
          else {
            if ((this.price_max!='' && this.price_max!=null) || (this.price_min!='' && this.price_min!=null)) {
              this.$store.dispatch('setFilters', {'p':1, currency: value}).then(() => {});
            }
            else {
              if ( value===this.$store.getters.user_currency.toUpperCase() ) value='';
              this.$store.dispatch('setFilters', {currency: value}).then(() => {});
            }
          }
        }
      },
    },
  },

  methods:{
    set_price_min: function(value){
      if (this.price_min===value) return;

      let val_str=value;
      if ( val_str!=null && val_str!==false && val_str>0 ) val_str=val_str.toString();
      let currency_val=this.currency.value;
      if ((this.price_max_in=='' || this.price_max_in==null) && (val_str=='' || val_str==null)) currency_val='';
      this.setFilters( {'p':1, price_min: val_str, currency: currency_val}, ()=>{this.set_tag_min(val_str);} );
    },

    set_price_max: function(value){
      if (this.price_max===value) return;

      let val_str=value;
      if ( val_str!=null && val_str!==false && val_str>0 ) val_str=val_str.toString();
      let currency_val=this.currency.value;
      if ((this.price_min_in=='' || this.price_min_in==null) && (val_str=='' || val_str==null)) currency_val='';
      this.setFilters({'p':1, price_max: val_str, currency: currency_val}, () => {this.set_tag_max(val_str);});
    },

    setFilters: function( filters, cl_f ){
      this.filters=Object.assign(this.filters, filters);
      if (cl_f!=null) this.cl_filters.push(cl_f);

      clearTimeout(this.T_filters);
      this.T_filters=setTimeout( ()=>{
        //console.log('SEND');
        //console.log(this.filters);
        this.$store.dispatch('setFilters', this.filters).then( ()=>{
          this.cl_filters.forEach(cl => cl());
          this.cl_filters=[];
        } );
        this.filters={};
      }, 10 );
    },

    set_tag_min: function(value){
      if (value>0) this.$store.dispatch('setTags',{price_min: {value: this.$t("message.PriceFrom")+' '+value + ' ' + this.valuesObj[this.currency_in].label, key: value}})
      else this.$store.dispatch('setTags',{price_min: {}}).then(()=>{});
    },

    set_tag_max: function(value){
      if (value>0) this.$store.dispatch('setTags',{price_max: {value: this.$t("message.PriceTo")+' '+value + ' ' + this.valuesObj[this.currency_in].label, key: value}})
      else this.$store.dispatch('setTags',{price_max: {}}).then(()=>{});
    },

    on_periodChange: function(price_min, price_max){},
  },

  destroyed : function () {
    this.$store.dispatch ('removeUsedFilters', 'Prices');
  },
}



//////////////////
// WEBPACK FOOTER
// ./src/components/list/filter/FilterPriceMix.js
// module id = null
// module chunks = 